import { Maximize2, Minus, X } from 'lucide-react';
import React, { useRef } from 'react';

const WindowComponent = ({ window, onUpdateWindow, onBringToFront, onMinimize, onMaximize, onClose, children }) => {
  const isDraggingRef = useRef(false);
  const dragOffsetRef = useRef({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    if (e.target.closest('.window-controls')) return;
    
    isDraggingRef.current = true;
    dragOffsetRef.current = {
      x: e.clientX - window.x,
      y: e.clientY - window.y
    };
    
    const handleMouseMove = (e) => {
      if (!isDraggingRef.current) return;
      const newX = Math.max(0, e.clientX - dragOffsetRef.current.x);
      const newY = Math.max(0, e.clientY - dragOffsetRef.current.y);
      onUpdateWindow(window.id, { x: newX, y: newY });
    };

    const handleMouseUp = () => {
      isDraggingRef.current = false;
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    
    onBringToFront(window.id);
  };

  if (window.isMinimized) return null;

  const IconComponent = window.icon;

  return (
    <div
      className={`absolute bg-white border border-gray-300 shadow-2xl ${
        window.isMaximized ? 'inset-0' : ''
      }`}
      style={{
        left: window.isMaximized ? 0 : window.x,
        top: window.isMaximized ? 0 : window.y,
        width: window.isMaximized ? '100%' : window.width,
        height: window.isMaximized ? '100%' : window.height,
        zIndex: window.zIndex,
        resize: window.resizable && !window.isMaximized ? 'both' : 'none',
        overflow: 'hidden'
      }}
      onClick={() => onBringToFront(window.id)}
    >
      {/* Title Bar */}
      <div
        className="flex items-center justify-between bg-white border-b border-gray-200 px-3 py-2 cursor-move select-none"
        onMouseDown={handleMouseDown}
      >
        <div className="flex items-center space-x-2">
          <IconComponent size={16} />
          <span className="text-sm font-medium text-gray-800">{window.title}</span>
        </div>

        <div className="window-controls flex items-center space-x-1">
          <button
            onClick={() => onMinimize(window.id)}
            className="w-8 h-8 flex items-center justify-center text-gray-600 hover:bg-gray-100 hover:text-gray-800 rounded transition-colors"
          >
            <Minus size={14} />
          </button>
          <button
            onClick={() => onMaximize(window.id)}
            className="w-8 h-8 flex items-center justify-center text-gray-600 hover:bg-gray-100 hover:text-gray-800 rounded transition-colors"
          >
            <Maximize2 size={14} />
          </button>
          <button
            onClick={() => onClose(window.id)}
            className="w-8 h-8 flex items-center justify-center text-gray-600 hover:bg-red-500 hover:text-white rounded transition-colors"
          >
            <X size={14} />
          </button>
        </div>
      </div>

      {/* Window Content */}
      <div className="h-full overflow-hidden" style={{ height: 'calc(100% - 42px)' }}>
        {children}
      </div>
    </div>
  );
};

export default WindowComponent;

